class NSSFooter extends HTMLElement {
  constructor() {
    super();
    this.debug = false;
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Footer] Connected.`);
  }
}

let elementName = `nss-footer`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSFooter);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
